import styled from 'styled-components';
const TextHeading1 = styled.h1`
  margin: 0;
  font-size: 52px;
  line-height: 64px;
  font-weight: 700;
  font-family: ${({
  theme
}) => theme.fontFamily.display};
  color: ${({
  theme
}) => theme.color.text};
`;
const TextHeading2 = styled.h2`
  margin: 0;
  font-size: 44px;
  line-height: 52px;
  font-weight: 700;
  font-family: ${({
  theme
}) => theme.fontFamily.display};
  color: ${({
  theme
}) => theme.color.text};
`;
const TextHeading3 = styled.h2`
  margin: 0;
  font-size: 34px;
  line-height: 44px;
  font-weight: 700;
  font-family: ${({
  theme
}) => theme.fontFamily.display};
  color: ${({
  theme
}) => theme.color.text};
`;
const TextHeading4 = styled.h3`
  margin: 0;
  font-size: 24px;
  line-height: 44px;
  font-weight: 700;
  font-family: ${({
  theme
}) => theme.fontFamily.display};
  color: ${({
  theme
}) => theme.color.text};
`;
const TextSubheadline = styled.h3`
  margin: 0;
  font-size: 14px;
  line-height: 24px;
  font-weight: 600;
  text-transform: uppercase;
  font-family: ${({
  theme
}) => theme.fontFamily.sans};
  color: ${({
  theme
}) => theme.color.text};
`;

// Note: supposed to use Inter font
const TextBodyLarge = styled.p`
  margin: 0;
  font-size: 20px;
  line-height: 36px;
  font-weight: 400;
  font-family: ${({
  theme
}) => theme.fontFamily.sans};
  color: ${({
  theme
}) => theme.color.text};
`;

// Note: supposed to use Inter font
const TextBodySmall = styled.p`
  margin: 0;
  font-size: 16px;
  line-height: 32px;
  font-weight: 400;
  font-family: ${({
  theme
}) => theme.fontFamily.sans};
  color: ${({
  theme
}) => theme.color.text};
`;
const Display1 = styled.h1`
  margin: 0;
  font-size: 64px;
  line-height: 72px;
  font-weight: 400;
  font-family: ${({
  theme
}) => theme.fontFamily.display};
  color: ${({
  theme
}) => theme.color.text};
`;
const Display2 = styled.h2`
  margin: 0;
  font-size: 34px;
  line-height: 44px;
  font-weight: 400;
  font-family: ${({
  theme
}) => theme.fontFamily.display};
  color: ${({
  theme
}) => theme.color.text};
`;
const Title1 = styled.h2`
  margin: 0;
  font-size: 28px;
  line-height: 36px;
  font-weight: 500;
  font-family: ${({
  theme
}) => theme.fontFamily.display};
  color: ${({
  theme
}) => theme.color.text};
`;
const Title2 = styled.h2`
  margin: 0;
  font-size: 28px;
  line-height: 36px;
  font-weight: 400;
  font-family: ${({
  theme
}) => theme.fontFamily.display};
  color: ${({
  theme
}) => theme.color.text};
`;
const Title3 = styled.h3`
  margin: 0;
  font-size: 20px;
  line-height: 28px;
  font-weight: 500;
  font-family: ${({
  theme
}) => theme.fontFamily.sans};
  color: ${({
  theme
}) => theme.color.text};
`;

// Note: supposed to use Inter font
const Headline = styled.h4`
  margin: 0;
  font-size: 16px;
  line-height: 24px;
  font-weight: 600;
  font-family: ${({
  theme
}) => theme.fontFamily.sans};
  color: ${({
  theme
}) => theme.color.text};
`;

// Note: supposed to use Inter font
const Body = styled.p`
  margin: 0;
  font-size: 16px;
  line-height: 24px;
  font-weight: 400;
  font-family: ${({
  theme
}) => theme.fontFamily.sans};
  color: ${({
  theme
}) => theme.color.text};
`;

// Note: supposed to use Inter font
const Label1 = styled.span`
  margin: 0;
  font-size: 14px;
  line-height: 16px;
  font-weight: 600;
  font-family: ${({
  theme
}) => theme.fontFamily.sans};
  color: ${({
  theme
}) => theme.color.text};
`;

// Note: supposed to use Inter font
const Label2 = styled.span`
  margin: 0;
  font-size: 14px;
  line-height: 16px;
  font-weight: 400;
  font-family: ${({
  theme
}) => theme.fontFamily.sans};
  color: ${({
  theme
}) => theme.color.text};
`;

// Note: supposed to use Inter font
const Caption = styled.span`
  margin: 0;
  font-size: 13px;
  line-height: 16px;
  font-weight: 600;
  text-transform: uppercase;
  font-family: ${({
  theme
}) => theme.fontFamily.text};
  color: ${({
  theme
}) => theme.color.text};
`;

// Note: supposed to use Inter font
const Legal = styled.p`
  margin: 0;
  font-size: 12px;
  line-height: 16px;
  font-weight: 400;
  font-family: ${({
  theme
}) => theme.fontFamily.text};
  color: ${({
  theme
}) => theme.color.text};
`;
export { Body, Caption, Display1, Display2, Headline, Label1, Label2, Legal, TextBodyLarge, TextBodySmall, TextHeading1, TextHeading2, TextHeading3, TextHeading4, TextSubheadline, Title1, Title2, Title3 };
//# sourceMappingURL=Text.js.map
